"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.3334 8.33341H1.66675M9.16675 11.6667H5.00008M1.66675 6.83341L1.66675 13.1667C1.66675 14.1002 1.66675 14.5669 1.8484 14.9234C2.00819 15.237 2.26316 15.492 2.57676 15.6518C2.93328 15.8334 3.39999 15.8334 4.33341 15.8334L15.6667 15.8334C16.6002 15.8334 17.0669 15.8334 17.4234 15.6518C17.737 15.492 17.992 15.237 18.1518 14.9234C18.3334 14.5669 18.3334 14.1002 18.3334 13.1667V6.83342C18.3334 5.89999 18.3334 5.43328 18.1518 5.07677C17.992 4.76316 17.737 4.50819 17.4234 4.34841C17.0669 4.16675 16.6002 4.16675 15.6667 4.16675L4.33342 4.16675C3.39999 4.16675 2.93328 4.16675 2.57676 4.3484C2.26316 4.50819 2.00819 4.76316 1.8484 5.07676C1.66675 5.43328 1.66675 5.89999 1.66675 6.83341Z",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;